/**
 * Canonical contact information for Keyprog.
 * Single source of truth — import from here instead of hardcoding.
 * Production values are overridden at runtime by Directus site_settings
 * when available; these serve as the offline / fallback defaults.
 */

export const CONTACT = {
  email: 'geral@keyprog.pt',
  supportEmail: 'suporte@keyprog.pt',
  phone: '+351 964 463 161',
  phonePlaceholder: '+351 964 463 161',
  domain: 'https://keyprog.pt',
} as const;

/** Directus admin base URL (from env, never hardcode localhost) */
export const DIRECTUS_ADMIN_URL = `${import.meta.env.VITE_DIRECTUS_URL || ''}/admin`;
